import React, { useEffect, useMemo } from "react";
import useSurveyForm from "../../hooks/useSurveyForm";
import FormProvider from "../../context/FormContext";
import SurveyContainer from "../../components/FormContainer/SurveyContainer";
import LoadingScreen from "../../screens/LoadingScreen";
import ErrorScreen from "../../screens/ErrorScreen";
import "./surveyfrom.css";
import { getSurveyEmail } from "../../utils/constants";

const SurveyForm = () => {
  const { merchant, data, fetching, error, fetch, formExpired, formSubmitted } =
    useSurveyForm();

  useEffect(() => {

    fetch(getSurveyEmail());
  }, []);

  const formData = useMemo(() => {
    if (!data || !data.data) return null;
    return { ...data.data, merchant };
  }, [data, merchant]);

  if (fetching && !data) {
    return <LoadingScreen />;
  }

  if (!fetching && error) {
    return (
      <ErrorScreen
        message={error || "Unable to load survey!"}
        refetch={()=>fetch(getSurveyEmail())}
      />
    );
  }

  if (formExpired) {
    return (
      <ErrorScreen
        message={"Sorry, this survey has expired!"}
        refetch={()=>fetch(getSurveyEmail())}
      />
    );
  }
  if (formSubmitted) {
    return (
      <ErrorScreen
        message={"You have submitted this survey, thank you for your feedback"}
        refetch={()=>fetch(getSurveyEmail())}
      />
    );
  }
  return (
    <div className="survey-page-wrapper">
      {!fetching && !error && formData && (
        <FormProvider {...formData}>
          <SurveyContainer />
        </FormProvider>
      )}
    </div>
  );
};

export default SurveyForm;
